import { hashKey, useQuery } from '@tanstack/react-query';

import { CompanyCriteria } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface ImportersMeta {
  total: number;
}

export const useImportersMeta = (filters: CompanyCriteria['filters']) =>
  useQuery({
    queryKey: ['importers-meta', hashKey([filters])],
    queryFn: async (filters?: any): Promise<ImportersMeta> => {
      try {
        const { metadata } = await request({
          path: `importer/retrieve-importers-metadata`,
          method: 'POST',
          authenticate: true,
          dataObject: { filters },
        });
        return { total: metadata.total };
      } catch (error) {
        showErrorToast(error, 'Failed to fetch importers metadata');
      }
    },
    placeholderData: {
      total: 0,
    },
  });
